module.exports = __webpack_public_path__ + "static/media/14-3.6291307e.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/14-3.png
// module id = 1675
// module chunks = 0 1